import { Permission } from "../Model/Permission";

export class GetPermissionsList {
    constructor(
      total,
      offset,
      limit,
      records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
      return new GetPermissionsList(
        data.total,
        data.offset,
        data.limit,
        data.records.map((record) => {
          return Permission.createFromResponseData(record);
        }),
      );
    }
  };